module.exports = __webpack_public_path__ + "static/profile-pic-ce34c208ed5c1b1ea8b1ce619bbd5cd9.jpg";